import { createApp } from "vue"
import VirtualScroller from "vue-virtual-scroller"
import router, { renderRoutes } from "@/router/index"
import pinia from "@/stores"
import i18n from "@/i18n/index"
import "vue-virtual-scroller/dist/vue-virtual-scroller.css"
import getTailwindConfig from "@/plugins/checkTailwindConfig"
import setFontSizeConfig from "@/plugins/fontSizeConfig"
import loadCustomSetting from "@/plugins/loadCustomSetting"
import stopDoubleTap from "@/plugins/stopDoubleTap"
import { plugin as dayjsConfigPlugin } from "@/plugins/dayJsConfig"
import { setWindowTitle, setQueryPass, setCertification } from "@/plugins/setWebsiteInfo"
import initSentry from "@/plugins/sentry"
import { initImageModules } from "@/composables/functional/useImages"
import App from "./App.vue"

const execute = async () => {
  try {
    const app = createApp(App)

    app.use(i18n)
    app.use(VirtualScroller)
    app.use(pinia)

    const websiteInfoStore = useWebsiteInfoStore()

    setQueryPass()
    setCertification()
    dayjsConfigPlugin()
    stopDoubleTap()
    getTailwindConfig()
    setFontSizeConfig()

    try {
      const res = await websiteInfoStore.getInitInfo()

      renderRoutes(router, { optional: res })
      setWindowTitle(res.webSiteDisplayName)

      await Promise.all([
        loadCustomSetting(res.webSiteCssName),
        initImageModules(res.webSiteCssName)
      ])

      initSentry({ app, router })
    } catch (err) {
      renderRoutes(router, { optional: {} })
      console.error("Unexpected error:", err)
    }

    app.use(router)
    app.mount("#app")
  } catch {
    console.log("redirect")
  }
}

execute()
